import { Component, OnInit } from '@angular/core';
import { AuthenticationModalComponent } from '../authentication-modal/authentication-modal.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-login',
  templateUrl: './authentication.component.html',
  styleUrls: ['./authentication.component.scss']
})
export class AuthenticationComponent implements OnInit {

  constructor(private matDialog: MatDialog) { }

  ngOnInit() {
    AuthenticationModalComponent.open(this.matDialog);
  }

}
